import {
  Box,
  KdsCardFile,
  KdsText,
  VStack,
} from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { useFile } from "@/hooks/queries/useFile";
import { type DispatchFileBlocProps } from "./DispatchFileBloc.types";

export const DispatchFileBloc = ({ dispatchFiles }: DispatchFileBlocProps) => {
  const { t } = useTranslate();

  const { useDownloadFileHandler } = useFile();
  const { handleDownloadFile } = useDownloadFileHandler();

  if (!dispatchFiles || !dispatchFiles.length) {
    return null;
  }

  return (
    <Box w="100%" rounded="br-md" bgColor="elevation.first" p="sp-md">
      <VStack gap="sp-md">
        <KdsText size="title-sm">
          {t("order.myOrdersItemDetails.dispatchFiles")}
        </KdsText>

        <Box maxH="450px" overflowY="auto">
          <VStack gap="sp-md">
            {dispatchFiles?.map((dispatchFile) => (
              <KdsCardFile
                key={dispatchFile.url}
                fileName={dispatchFile.fileName}
                fileSize={dispatchFile.size}
                fileUrl={dispatchFile.url}
                isViewable
                isDownloadable
                onDownload={() =>
                  handleDownloadFile(dispatchFile.fileName, dispatchFile.url)
                }
              />
            ))}
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
};
